import React from 'react';

export const Home: React.FC<{}> = () => {
    return (
        <div>
            <h2>Bygr admin tool</h2>
            <div>
                <img alt="Splash" src="/images/splash.png" />
            </div>
        </div>
    );
};
